import { render } from "./UiSortMenu.vue?vue&type=template&id=aec72efe&ts=true"
import script from "./UiSortMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./UiSortMenu.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/UiSortMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "aec72efe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('aec72efe', __exports__)) {
    api.reload('aec72efe', __exports__)
  }
  
  module.hot.accept("./UiSortMenu.vue?vue&type=template&id=aec72efe&ts=true", () => {
    api.rerender('aec72efe', render)
  })

}


export default __exports__